import type { VaultRiskLimit, VaultState } from 'src/pages/admin/services/vaultService';

export const VAULTS_PERMISSION_RESOURCE = 'vault:vaults';

export const VAULTS_NS = 'module.vaults';

/** C-06 `VaultState`, in schema order; the engine stays the authority. */
export const VAULT_STATES: readonly VaultState[] = [
  'DRAFT',
  'RAISING',
  'ACTIVE',
  'PAUSED',
  'CLOSING',
  'CLOSED',
];

/** The VaultSwitcher `value` that means every vault when it offers that choice (§14.6 Records). */
export const ALL_VAULTS_VALUE = 'all';

/** XBIT-4258: the new manager address, 0x + 40 hex in any case (the engine stores it EIP-55). */
export const EVM_ADDRESS = /^0x[0-9a-fA-F]{40}$/;

/** XBIT-4258: a manager address change's reason, 1–500 characters after trimming (the engine's bound). */
export const MANAGER_ADDRESS_REASON_MAX = 500;

/** XBIT-4242: an operations pause's reason, 1–500 characters after trimming (the engine's bound). */
export const PAUSE_REASON_MAX = 500;

/** XBIT-4243: a closure's reason, 1–500 characters after trimming (the BFF's bound; the contract names none). */
export const CLOSURE_REASON_MAX = 500;

/** C-06 `VaultRiskLimit`, in schema order (XBIT-4764); the engine stays the authority. */
export const RISK_LIMITS: readonly VaultRiskLimit[] = [
  'INSTRUMENT_WHITELIST',
  'MAX_LEVERAGE',
  'CONCENTRATION',
  'MARGIN_WARNING',
  'FORCED_DELEVERAGE',
];

/** The limit whose open episode turns the badge red. */
export const RISK_CRITICAL_LIMIT: VaultRiskLimit = 'FORCED_DELEVERAGE';

/**
 * The open-only read behind the badge and the default table: one episode is open at most per (vault, limit)
 * (uq_vrb_open), so a page of the limit count holds EVERY open one. The badge never fetches closed episodes.
 */
export const RISK_OPEN_PAGE_LIMIT = RISK_LIMITS.length;

/** "Show all" pages like the console's other lists; every size is within the engine's 1–200. */
export const RISK_ROWS_PER_PAGE_OPTIONS = [20, 50, 100];
export const RISK_DEFAULT_ROWS_PER_PAGE = 20;
